"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOauthRedirectURIsRequired = void 0;
var _utils = require("../GrantTypes/utils");
var isOauthRedirectURIsRequired = exports.isOauthRedirectURIsRequired = function isOauthRedirectURIsRequired(_ref) {
  var form = _ref.form;
  var implicit = form[(0, _utils.getGrantTypeValueKey)('implicit')];
  var authorizationCode = form[(0, _utils.getGrantTypeValueKey)('authorization_code')];
  return implicit || authorizationCode;
};
//# sourceMappingURL=utils.js.map